import React from "react";
import Header from "../../components/Header/Header";
import Footer from "../../components/Footer/Footer";

import {
    CompetitionGal1,
    CompetitionGal2,
    CompetitionGal3,
    CompetitionGal4,
    CompetitionGal5,
    CompetitionGal6,
} from "../../constant";
import { Link } from 'react-router-dom'
import ContactSec from "../../components/ContactSec";
const CompetitionGallery = () => {
    const GalleryImages = [
        {
            id: 1,
            image: CompetitionGal1,
        },
        {
            id: 2,
            image: CompetitionGal2,
        },
        {
            id: 3,
            image: CompetitionGal3,
        },
        {
            id: 4,
            image: CompetitionGal4,
        },

        {
            id: 5,
            image: CompetitionGal5,
        },
        {
            id: 6,
            image: CompetitionGal6,
        },
        {
            id: 7,
            image: CompetitionGal4,
        },
        {
            id: 8,
            image: CompetitionGal2,
        },
        {
            id: 9,
            image: CompetitionGal3,
        },
        {
            id: 10,
            image: CompetitionGal1,
        },
        {
            id: 11,
            image: CompetitionGal2,
        },
        {
            id: 12,
            image: CompetitionGal3,
        },
        {
            id: 13,
            image: CompetitionGal4,
        },

        {
            id: 14,
            image: CompetitionGal5,
        },
        {
            id: 15,
            image: CompetitionGal6,
        },
        {
            id: 16,
            image: CompetitionGal3,
        },
        {
            id: 17,
            image: CompetitionGal2,
        },
        {
            id: 18,
            image: CompetitionGal3,
        }
    ];
    return (
        <>
            {/* Header Start Here */}
            <Header />
            {/* Header End Here */}
            {/* Gallery Start Here */}
            <section className="photo-gallery without-back">
                <div className="container">
                    <div className="col-xxl-11 mx-auto mt-3">
                        <div className="col-lg-6 mx-auto px-xl-4">
                            <div className="top-heading text-center">
                                <h6 className="small-heading mb-0">
                                    Manchester Islamic Centre
                                </h6>
                                <h2 className="mb-0">Competition Gallery</h2>
                                <p className="mb-0">
                                    Sed cras ornare arcu dui vivamus arcu felis bibendum ut.
                                    Tempus egestas sed sed risus pretium quam vulputate
                                    dignissim. Quam pellentesque nec nam aliquam
                                </p>
                            </div>
                        </div>
                    </div>
                    <div className="gallery-main mb-lg-5">
                        <div className="col-xxl-11 mx-auto">
                            <div className="gallery-start">

                                <div className="galler-images">
                                    <div className="row">
                                        {GalleryImages.map((data, index) => (
                                            <div className="col-md-4 p-2" key={index}>
                                                <figure>
                                                    <img src={data.image} className="img-fluid" alt="" />
                                                </figure>
                                            </div>
                                        ))}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            {/* Gallery End Here */}

            <ContactSec />
            {/* Footer Start Here */}
            <Footer />
            {/* Footer End Here */}
        </>
    );
};

export default CompetitionGallery;